class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }

  // Shared by every search entry point (header search, search template) so a term matching
  // a product tag exactly always redirects to the tag-scoped product search.
  static redirectToTagIfMatch(form, searchInput) {
    if (!searchInput) return false;

    const searchTerm = searchInput.value.trim();
    if (!searchTerm) return false;

    if (!window.all_tags || !Array.isArray(window.all_tags)) return false;

    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    const isTag = window.all_tags.some((tag) => tag.toLowerCase() === lowerCaseSearchTerm);
    if (!isTag) return false;

    window.location.href = `${form.action}?q=tag:${encodeURIComponent(searchTerm)}&type=product`;
    return true;
  }
}

customElements.define('search-form', SearchForm);
